// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1ejS7","label":"LabeledBox_label__3aLE8"};